import { Injectable } from "@angular/core";
import { InitService } from "@core-services/init.service";
import { SocketService } from "@main-services/socket.service";
import { TranslationService } from "@core-services/translation.service";
import { DestructorService } from "@core-services/destructor.service";
import { debug } from "@helpers/debug";
import { LeveragedToken } from "@models/asset/cryptocoins/currencies/leveraged_tokens";
import { AssetService } from "@main-services/currency/asset.service";
import { LaunchDarklyService } from "@core-services/launch-darkly/launch-darkly.service";

@Injectable({
	providedIn: "root"
})
export class LeveragedTokenService extends AssetService<LeveragedToken> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected destructor: DestructorService,
		protected launchDarklyService: LaunchDarklyService
	) {
		super(initService, destructor, translationService, socketService, "LeveragedTokenService");
	}

	override set list(m: LeveragedToken[]) {
		this.log([...this.list], m, "update_list");
		this.initService.init(this.name);
		this._list.next(m);
	}

	override get list(): LeveragedToken[] {
		return this._list.getValue().filter((i: LeveragedToken) => !!i);
	}

	public logoUrl(item: LeveragedToken, grayVersion: boolean = false): string {
		let url = "assets/images/logos/";

		if (grayVersion) {
			url += "leveragedTokens/" + item.getSymbol(true) + "-grey-half-transparent";
		} else {
			url += "leveragedTokens/leveragedToken-" + item.getSymbol(true);
		}

		return url;
	}

	public startSockets(): void {
		if (debug) {
			console.log("[DEBUG]: listen to leveraged token updates");
		}

		const priceRoom = {
			room: "leveraged_token_prices",
			collection: "leveraged_tokens",
			type: LeveragedToken,
			isPrivate: false
		};
		const assetRoom = {
			room: "leveraged_tokens",
			collection: "leveraged_tokens",
			type: LeveragedToken,
			isPrivate: false
		};
		this.initSockets(priceRoom, assetRoom);
	}
}
